module.exports = '1.0.1';


//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/version.js
// module id = 41
// module chunks = 0